import { useEffect, useState } from "react";
import userManager from "../features/authorization/authService";

import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import {
  loadInitialAuthenticationStateAsync,
  selectAuthInitializationStatus,
} from "../features/authentication/authenticationSlice";
import { ROUTES } from "../routes";
import { StringExtension } from "../features/extensions/StringExtension";

const AuthorizeRedirectPage = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const initializationStatus = useAppSelector(selectAuthInitializationStatus);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isCallback = urlParams.has("code") || urlParams.has("state");

    if (isCallback) {
      userManager
        .signinRedirectCallback()
        .then(() => {
          setLoading(false);
          dispatch(loadInitialAuthenticationStateAsync());
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [navigate, dispatch]);

  useEffect(() => {
    if (loading === false) {
      const stringExtension = new StringExtension();
      let redirectUrl = localStorage.getItem("redirectUrl") || ROUTES.HOME;
      if (stringExtension.isEquals(redirectUrl, ROUTES.LOGIN)) {
        redirectUrl = ROUTES.HOME;
      }
      navigate(redirectUrl);
    }
  }, [loading, navigate]);

  if (initializationStatus === "not-initialized" || loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <svg className="animate-spin h-10 w-10 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
        </svg>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center h-screen">
      <span className="text-xl font-semibold">You successfully authorized</span>
    </div>
  );
};

export default AuthorizeRedirectPage;
